<template>
    <div class="feed-url">
        <div class="step-title">
            Switch to a new host.
        </div>

        <div class="step-description">
            To ensure we prepare your account to disable Easy Hosting, please enter the RSS feed from your new host below.
        </div>

        <p class="feed-url-label">
            Enter your show RSS URL
        </p>

        <form
            novalidate
            @submit.prevent="processForm"
        >
            <div class="input-group">
                <input
                    v-model="url"
                    class="feed-url"
                    :disabled="formProcessing"
                    type="text"
                    @click="clearErrors"
                >
                <span
                    v-if="'' !== errorMessage"
                    class="error-message rss-error-message"
                >
                    {{ errorMessage }}
                </span>
            </div>

            <transition
                name="fade"
                mode="out-in"
            >
                <base-form-button
                    v-if="!formProcessing"
                    class="btn"
                    :has-arrow="true"
                >
                    Let's Get Started
                </base-form-button>

                <div
                    v-else
                    class="loading-message"
                >
                    <i
                        key="spinner"
                        class="fas fa-spinner fa-spin"
                    />
                    Loading your podcast information. Please wait...
                </div>
            </transition>
        </form>

        <a class="feed-rss-url" href="https://support.fusebox.fm/article/438-find-rss-url">Where can I find my RSS URL?</a>
    </div>
</template>

<script>
import apiCall from '@/utils/apiCall';
import toasts from '@/mixins/toasts';

export default {
    mixins: [toasts],

    props: {
        show: {
            type: [Boolean, Object],
            default: () => ({}),
        },
    },

    data: () => ({
        url: '',
        formProcessing: false,
        errorMessage: '',
    }),

    methods: {

        /**
         * Validate if input is not empty
         *
         * @returns  {boolean} If field is valid
         */
        validate() {
            if ('' === this.url) {
                this.errorMessage = 'Please enter show RSS URL';
                return false;
            }

            return true;
        },

        /**
         * Validates show.
         *
         * @returns {boolean} Validation result.
         */
        async validateShow() {
            const route = `/api/shows/${this.show.hash}/import/validate`;
            const { status, data } = await apiCall(this, 'post', route, { feedUrl: this.url });

            if (200 !== status) {
                if (data?.errors?.feedUrl[0]) {
                    this.errorMessage = data.errors.feedUrl[0];
                } else {
                    this.errorMessage = data;
                }

                return false;
            }

            return true;
        },

        /**
         * Clears errors.
         */
        clearErrors() {
            this.errorMessage = '';
        },

        /**
         * Handle process form action
         *
         */
        async processForm() {
            if (! this.validate()) {
                return;
            }

            if (! await this.validateShow()) {
                return;
            }

            const { status, data } = await apiCall(this, 'post', '/api/shows/import', { feedUrl: this.url });

            if (200 !== status) {
                if (data?.errors?.feedUrl[0]) {
                    this.errorMessage = data.errors.feedUrl[0];
                }

                this.toastError({
                    message: {
                        title: data.message || data,
                    },
                });

                return;
            }

            this.$emit('change-step', data);
            this.$emit('change-step-next', data);
        },
    },
};
</script>
